export { AtnDsIntegratedHorizontalTabsComponent as Component } from './integrated-horizontal-tabs.component'
